import styled from 'styled-components';
import tw, { css } from 'twin.macro';

export const StyledTimeInputField = styled.input(({ $invalid, $readOnly, $extraWide }) => [
  tw` border-silver-darken-20 text-black text-opacity-85 `,
  css`
    height: 2.25rem;
  `,
  $extraWide
    ? css`
        width: 6.5rem;
        ${tw`px-4`}/* Lower padding inline so AM/PM timeformat fits */
      `
    : css`
        width: 5.85rem;
        ${tw`px-8`}
      `,
  $invalid && !$readOnly && tw`border-red-base border-2 text-red-base`,
  $readOnly &&
    css`
      width: fit-content;
      height: 1.5rem;
      ${tw` border-none p-0 bg-transparent`}
    `
]);

export default StyledTimeInputField;
